interface PenPathPreviewProps {
  /** Path `d` through the committed anchors (empty before the first anchor). */
  committedD: string
  pointCount: number
  /** Rubber-band `d` from the last anchor to the cursor (empty when hidden). */
  rubberBandD: string
  /** Stroke width (canvas units). */
  sw: number
  /** Dash segment length (canvas units). */
  dashLen: number
}

const PATH_STROKE = '#737373'

/** The in-progress path: closed-fill preview, committed segments and the rubber band to the
 *  cursor. */
export function PenPathPreview({
  committedD,
  pointCount,
  rubberBandD,
  sw,
  dashLen,
}: PenPathPreviewProps) {
  return (
    <>
      {/* Fill preview — shown once 3+ anchors are committed (renders closed shape) */}
      {committedD && pointCount >= 3 && (
        <path
          d={`${committedD} Z`}
          fill="rgba(180,180,180,0.35)"
          stroke="none"
          pointerEvents="none"
        />
      )}

      {/* Committed segments */}
      {committedD && (
        <path
          d={committedD}
          fill="none"
          stroke={PATH_STROKE}
          strokeWidth={sw}
          strokeLinecap="round"
          strokeLinejoin="round"
          pointerEvents="none"
        />
      )}

      {/* Rubber-band preview to cursor */}
      {rubberBandD && (
        <path
          d={rubberBandD}
          fill="none"
          stroke={PATH_STROKE}
          strokeWidth={sw}
          strokeDasharray={`${dashLen},${dashLen}`}
          strokeLinecap="round"
          pointerEvents="none"
        />
      )}
    </>
  )
}
